import { useQuery } from '@tanstack/react-query';

import { getQueryKey } from '@/api/utils/getQueryKey';
import { getResolvedEndpoint } from '@/api/utils/getResolvedEndpoint';
import { handleApiCall } from '@/api/utils/handleApiCall';
import { useAuth } from '@/context/AuthProvider';

interface PaymentBreakdownResponse {
  breakdown: {
    baseRent: number;
    fees: Array<{
      name: string;
      amount: number;
    }>;
    total: number;
    potentialProcessingFees?: {
      card: {
        percentage: number;
        fixed: number;
        domestic: number;
        manualEntry: number;
        international: number;
        currencyConversion: number;
      };
      instantBankPayment: {
        percentage: number;
        fixed: number;
        total: number;
      };
      achDirectDebit: {
        percentage: number;
        cap: number;
        total: number;
      };
    };
  };
}

const METHOD = 'GET';
const ENDPOINT = 'unit/:id/payment-breakdown';
export const QUERY_KEY = (unitId: number) => getQueryKey(METHOD, ENDPOINT, { id: unitId });

export const useGetPaymentBreakdown = (unitId: number, enabled = true) => {
  const { session } = useAuth();

  return useQuery({
    enabled: enabled && !!session?.access_token,
    queryKey: QUERY_KEY(unitId),
    queryFn: async () => {
      try {
        const data = await handleApiCall<PaymentBreakdownResponse>(
          session,
          METHOD,
          getResolvedEndpoint(ENDPOINT, {
            id: unitId.toString(),
          })
        );

        return data;
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error(err);

        throw err;
      }
    },
  });
};
